import { createApi } from '@reduxjs/toolkit/query/react';

import { Lang } from '@assets/locales';

import { TAG_RACE, TAG_RUNNERS } from '../../config/tags';
import { SCHEDULE_RACES, SCHEDULE_RUNNERS } from '../../config/urls';
import { adaptRunners } from '../adapters/runners';

import { baseQuery } from './baseQuery';

import type { Runner } from '../types';
import type { ApiRunner } from '../types/apiRunner';

export type RunnersArgs = {
  date: string;
  racecourseCode?: string | null;
  raceNumber: number;
  language: Lang;
};

// Define a service using a base URL and expected endpoints
export const runnersApi = createApi({
  reducerPath: 'runnersApi',
  tagTypes: [TAG_RACE, TAG_RUNNERS],
  baseQuery,
  refetchOnFocus: true,
  endpoints: builder => ({
    getRunners: builder.query<Runner[], RunnersArgs>({
      query: ({ date, racecourseCode, raceNumber, language }) => ({
        url: `${SCHEDULE_RACES}/${date}/${racecourseCode}/${raceNumber}/${SCHEDULE_RUNNERS}`,
        params: { language },
      }),
      transformResponse: (response: ApiRunner[]): Runner[] => adaptRunners(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRunnersQuery, useLazyGetRunnersQuery } = runnersApi;
